import * as type from './constant';

export const getTaskClassification = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getTaskClassificationSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getTaskClassificationError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addTaskClassification = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addTaskClassificationSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateTaskClassification = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateTaskClassificationSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteTaskClassification = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteTaskClassificationSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationTaskClassificationError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
